// 返回头部，以及二维码
<template lang="pug">
.back-top-ercode-wrap
  .ercode
    img(:src="ercode", alt="loklok download ercode")
  div(:data-bury-params="JSON.stringify({UM_Key_ButtonName:'下载app'})")
    nuxt-link.download-btn(:to="localePath('/download_nd')") {{ $t('navigator.download') }}
  .back-top(v-show="hasBackTop" @click="handleBackTop")
    .iconfont.icon-arrow3_s
    span Back TOP
</template>

<script>
export default {
  name: 'back-top-ercode',
  data() {
    return {}
  },
  props: {
    ercode: {
      type: String,
      default: 'https://static.loklok.video/img/dwercode220124.png?imageMogr2/format/webp'
    },
    hasBackTop: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '请扫码下载LoklokAPP，观看更多影视内容'
    }
  },
  methods: {
    handleBackTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="sass" scoped>
.back-top-ercode-wrap
  .ercode
    @include square(160px, 16px)
    background: #fff
    @include flex-center
    img
      @include square(140px, 0px)
  .download-btn
    cursor: pointer
    margin-top: 20px
    @include rect(40px, 160px, 40px)
    background: $mainColor
    font-weight: bold
    font-size: 16px
    line-height: 120%
    color: $mainTextColor
    display: block
    @include flex-center
  .back-top
    cursor: pointer
    margin-top: 20px
    @include rect(40px, 160px, 40px)
    background: $backgroundColor1
    font-weight: bold
    font-size: 16px
    line-height: 120%
    color: $mainTextColor
    display: block
    @include flex-center
    .iconfont
      font-size: 28px
      margin-right: 12px
      font-weight: normal
</style>
